import type { FrontendModule } from '@/lib/types'

import { ModulesPage } from './pages/ModulesPage'
import { RolesPage } from './pages/RolesPage'
import { UsersPage } from './pages/UsersPage'

/**
 * Moduł `admin` — panel administracyjny (ekrany z `design/screens`).
 *
 * Ścieżki muszą być identyczne z `NavItem.route` w manifeście backendu
 * (`app/modules/admin/module.py`) — nawigacja idzie wyłącznie z `/api/me/context`.
 */
export const adminModule: FrontendModule = {
  key: 'admin',
  routes: [
    { path: 'administracja/moduly', element: <ModulesPage /> },
    { path: 'administracja/role', element: <RolesPage /> },
    { path: 'administracja/uzytkownicy', element: <UsersPage /> },
  ],
}

export default adminModule
